import { useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import Card from "../components/Card";

const Search = () => {
    const [searchParams] = useSearchParams();
    const queryTerm = searchParams.get('q');
    
    const [movies, setMovies] = useState([]);
    const url = `https://api.themoviedb.org/3/search/movie?api_key=${process.env.REACT_APP_MOVIEDB_API}&query=${queryTerm}`

    useEffect(() => {
        async function fetchData(){
            const response = await fetch(url);
            const data = await response.json();
            setMovies(data.results);
        }
        fetchData();
    }, [url]);

    useEffect(() => {
        document.title = `Search result for ${queryTerm} / Cinemate`;
    }, [queryTerm]);

    return (
        <>            
            <section className="max-w-7xl mx-auto py-7">
                <p className="text-3xl text-gray-700 dark:text-white">{ movies.length === 0 ? `No result found for '${queryTerm}'` : `Results for '${queryTerm}'` } </p>
            </section>
            <section className="max-w-7xl mx-auto py-7">
                <div className="flex justify-start flex-wrap other:justify-evenly">
                    {movies.map(({id, poster_path, original_title, overview, vote_average, vote_count}) => (
                        <Card key={id} id={id} poster={poster_path} title={original_title} overview={overview} vote_average={vote_average} vote_count={vote_count}/>
                    ))}
                </div>
            </section>
        </>
    );
}

export default Search;